import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "../../../../util/cookie/cookies";

export const AboutHistory = () => {
    const [state, setState] = useState<number>(1)
    const lang = getCookie('HYUNDAILANG')
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div>
                <div className="left stickyBox">
                    {lang === 'kr' ? 
                    <h3>
                        <span>현대엔테크가</span>
                        걸어온 길
                    </h3>
                    :
                    <h3>
                        The path HyunDaiEnTech Walked
                    </h3>
                    }
                    <ul className="tabBtnBox">
                        <li className={state===1?'active':''} onClick={()=>setState(1)}>2020's</li>
                        <li className={state===2?'active':''} onClick={()=>setState(2)}>2010's</li>
                        <li className={state===3?'active':''} onClick={()=>setState(3)}>2000's</li>
                        <li className={state===4?'active':''} onClick={()=>setState(4)}>1990's</li>
                    </ul>
                </div>
                <div className="right">
                    <div className="imgBox">
                        <img src="/assets/images/history.png" alt="연혁"/>
                    </div>
                    <div className="tableWrap">
                        <table>
                            <tbody>
                                <tr>
                                    <th>2021</th>
                                    <td>{t("about_history_1")}</td>
                                </tr>
                                <tr>
                                    <th></th>
                                    <td>{t("about_history_2")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="tableWrap">
                        <table>
                            <tbody>
                                <tr>
                                    <th>2020</th>
                                    <td>{t("about_history_3")}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}